import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import Angela1C from "../Common/Angela/Angela1C";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class PlantManagerDashboard extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    Dict001: null,
    Dict002: null,
    Dict003: null,
    Dict004: null,
    Dict005: null,
    Dict006: null,
    Dict007: null,
    Dict008: null,
    Dict009: null,
    Dict010: null,
    Dict011: null,
    Dict012: null,
    Dict013: null,
    Dict014: null,
    Dict015: null,
    Dict016: null,
    Dict017: null,
    Dict018: null,
    Dict019: null,
    Dict020: null,
    Dict021: null,
    dataLoading: false,
    // Houdini_nullData
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    // this.props.setPageHeader("Plant Manager Dashboard");
    this._isMounted = true;
    this.fetchChartData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchChartData = (selectedTab = "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/plantmanagerdashboard", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "PlantManagerDashboard",
      })
      .then(({ data }) => {
        const resp = { ...data };
        this.props.setPageHeader(resp.config?.pageTitle || "Plant Manager Dashboard");
        let respData = {};
        respData["Dict001"] = resp["data"]["Dict001"];
        respData["Dict002"] = resp["data"]["Dict002"];
        respData["Dict003"] = resp["data"]["Dict003"];
        respData["Dict004"] = resp["data"]["Dict004"];
        respData["Dict005"] = resp["data"]["Dict005"];
        respData["Dict006"] = resp["data"]["Dict006"];
        respData["Dict007"] = resp["data"]["Dict007"];
        respData["Dict008"] = resp["data"]["Dict008"];
        respData["Dict009"] = resp["data"]["Dict009"];
        respData["Dict010"] = resp["data"]["Dict010"];
        respData["Dict011"] = resp["data"]["Dict011"];
        respData["Dict012"] = resp["data"]["Dict012"];
        respData["Dict013"] = resp["data"]["Dict013"];
        respData["Dict014"] = resp["data"]["Dict014"];
        respData["Dict015"] = resp["data"]["Dict015"];
        respData["Dict016"] = resp["data"]["Dict016"];
        respData["Dict017"] = resp["data"]["Dict017"];
        respData["Dict018"] = resp["data"]["Dict018"];
        respData["Dict019"] = resp["data"]["Dict019"];
        respData["Dict020"] = resp["data"]["Dict020"];
        respData["Dict021"] = resp["data"]["Dict021"];
        respData["Dict022"] = resp["data"]["Dict022"];
        respData["Dict023"] = resp["data"]["Dict023"];

        // Houdini_RespData

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              // paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                    // style={{
                    //   margin: "10px",
                    //   padding: "10px",
                    // }}
                    >
                      {/* <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                        Plant Manager Dashboard
                      </div> */}

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      {/* <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row> */}

                      {/* _______Row No 1________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict001"}
                              data={this.state.Dict001.data}
                              config={this.state.Dict001.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict002"}
                              data={this.state.Dict002.data}
                              config={this.state.Dict002.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict003"}
                              data={this.state.Dict003.data}
                              config={this.state.Dict003.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict004"}
                              data={this.state.Dict004.data}
                              config={this.state.Dict004.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict021"}
                              data={this.state.Dict021.data}
                              config={this.state.Dict021.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict005"}
                              data={this.state.Dict005.data}
                              config={this.state.Dict005.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 2________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict006"}
                              data={this.state.Dict006.data}
                              config={this.state.Dict006.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict007"}
                              data={this.state.Dict007.data}
                              config={this.state.Dict007.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict008"}
                              data={this.state.Dict008.data}
                              config={this.state.Dict008.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict009"}
                              data={this.state.Dict009.data}
                              config={this.state.Dict009.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict010"}
                              data={this.state.Dict010.data}
                              config={this.state.Dict010.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict011"}
                              data={this.state.Dict011.data}
                              config={this.state.Dict011.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* _______Row No 3________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict012"}
                              data={this.state.Dict012.data}
                              config={this.state.Dict012.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict013"}
                              data={this.state.Dict013.data}
                              config={this.state.Dict013.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict014"}
                              data={this.state.Dict014.data}
                              config={this.state.Dict014.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>


                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict022"}
                              data={this.state.Dict022.data}
                              config={this.state.Dict022.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict023"}
                              data={this.state.Dict023.data}
                              config={this.state.Dict023.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>



                      </Row>
                      {/* _______Row No 4________ */}
                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict015"}
                              data={this.state.Dict015.data}
                              config={this.state.Dict015.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict016"}
                              data={this.state.Dict016.data}
                              config={this.state.Dict016.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict017"}
                              data={this.state.Dict017.data}
                              config={this.state.Dict017.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict018"}
                              data={this.state.Dict018.data}
                              config={this.state.Dict018.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict019"}
                              data={this.state.Dict019.data}
                              config={this.state.Dict019.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>

                        <Col style={{ width: "15%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <Angela1C
                              divId={"Dict020"}
                              data={this.state.Dict020.data}
                              config={this.state.Dict020.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Houdini_DivData */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default PlantManagerDashboard;
